import { useState } from "react";
import { deleteWeavingAlertEvent } from "../../_events/weaving_alert/delete.event";
import { message } from "antd";

export const useDeleteWeavingAlert = (onSuccess) => {
    const [loading, setLoading] = useState(false);

    const deleteAlert = (id) => {
        setLoading(true);
        deleteWeavingAlertEvent(id)
        .then(_ => {
            message.success('Alerta eliminada');
            onSuccess?.();
            setLoading(false);
        })
        .catch(error => {
            message.error(error.message);
            setLoading(false);
        });
    } 

    return{
        loading,
        deleteAlert
    };
}